import React from "react";
import EngineClusterPage from "../../../../components/pages/_new/super/engines/EngineClusterPage";

const AdClusterPage = () => <EngineClusterPage engineType="AD_ENGINE" />;

export default AdClusterPage;
